'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var styled = require('styled-components');
var styled__default = _interopDefault(styled);

var Container = styled__default.div(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n"], ["\n  display: flex;\n  flex-direction: column;\n"])));
var SelectContent = styled__default.div(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n  background-color: ", ";\n  box-shadow: 0px -6px 10px -5px ", "1A;\n  border: 1px solid ", ";\n  display: flex;\n  flex-direction: column;\n  margin: 0 0 12px 0;\n  padding: ", ";\n  height: ", ";\n  opacity: ", ";\n"], ["\n  background-color: ", ";\n  box-shadow: 0px -6px 10px -5px ", "1A;\n  border: 1px solid ", ";\n  display: flex;\n  flex-direction: column;\n  margin: 0 0 12px 0;\n  padding: ", ";\n  height: ", ";\n  opacity: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.$white;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.adminBlack;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.$sharedGreyLight;
}, function (_a) {
    var isSelected = _a.isSelected;
    return "" + (isSelected ? '15px' : 0);
}, function (_a) {
    var isSelected = _a.isSelected;
    return "" + (isSelected ? 'auto' : 0);
}, function (_a) {
    var isSelected = _a.isSelected;
    return "" + (isSelected ? 1 : 0);
});
var templateObject_1, templateObject_2;

exports.Container = Container;
exports.SelectContent = SelectContent;
